import CoreuiController from "../lib/coreui-controller"
import Navigation from "../coreui/navigation"

export default class CoreuiNavigationController extends CoreuiController {
  static Component = Navigation
}
